export default {
  cdn: 'https://wa.cdn-surfline.com/web-backplane/',
  surflineHost: 'https://www.surfline.com',
  servicesURL: 'https://services.surfline.com',
  htl: {
    scriptUrl: 'https://htlbid.com/v3/surfline.com/htlbid.js',
    cssUrl: 'https://htlbid.com/v3/surfline.com/htlbid.css',
    isTesting: 'no',
  },
  appKeys: {
    segment: 'Se6IGuzcvUhLx55hLHL0RiXkS6oUTz8L',
    splitio: process.env.SPLITIO_AUTHORIZATION_KEY || 'in20v2ebf6q1gh97ldcn1bp8ufdbr404e514',
  },
  clientId: '5c59e7c3f0b6cb1ad02baf66',
  clientSecret: 'sk_QqXJdn6Ny5sMRu27Amg3',
  useSheMedia: false,
};
